import React from "react";
import { components } from "react-select";
import iconSearch from "../select/images/icon-search.svg";

const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <div style={{ marginRight: "10px" }}>
          <img src={iconSearch} alt="Search" />
        </div>
      </components.DropdownIndicator>
    )
  );
};

export default DropdownIndicator;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/spocketUI/components/select/DropdownIndicator.js